import React, { type FC, memo } from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import styles from "./Overview.module.scss";
import summaryStyles from "../Summary.module.scss";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import { useCarConfigSelector } from "../../../../../redux/store";
import SummarySpecifications from "../SummarySpecifications";
import Price from "../../price/Price";
import { useTabsContext } from "../SummaryTabsContext";
import type { SummaryTabPropsTypes } from "../../../../../hooks/useAphSummaryTabs";
import OverviewEngine from "./OverviewEngine";
import OverviewColour from "./OverviewColour";
import OverviewWheels from "./OverviewWheels";
import OverviewUpholstery from "./OverviewUpholstery";
import OverviewPacksAndExtras from "./OverviewPacksAndExtras";
import OverviewChargers from "./OverviewCharging";
import SummaryServices from "../tabs/SummaryServices";
import SummaryManufacturerInfo from "../SummaryManufacturerInfo";

const SummaryOverview: FC<SummaryTabPropsTypes> = (props) => {
    const { tabId, tab } = props;
    const tabsContext = useTabsContext();
    const car = useCarConfigSelector((state) => state.car);

    return (
        <section
            className={summaryStyles["tab-panel"]}
            role="tabpanel"
            id={tabId}
            aria-labelledby={tab}
            hidden={tabsContext.openTab !== "overview"}
        >
            <div className={styles.startprice}>
                <Text tag="div" variant="apheleia-body" className={styles.title}>
                    <CarConfigLabel label="carConfigOverviewTilePriceStartingPrice" />
                </Text>
                <div>
                    <Price price={car.price} />
                </div>
            </div>
            <div>
                <ul className={styles.mainlist} role="list">
                    <OverviewEngine />
                    <OverviewColour />
                    <OverviewWheels />
                    <OverviewUpholstery />
                    <OverviewPacksAndExtras />
                    <OverviewChargers />
                </ul>
                <SummaryServices />
                <SummaryManufacturerInfo />
                <SummarySpecifications />
            </div>
        </section>
    );
};

export default memo(SummaryOverview);
